import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
  ResponsiveContainer, PieChart, Pie, Cell,
} from 'recharts';
import {colors} from '../../../../common/constants/colors';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = (props) => {
  const {cx, cy, midAngle, outerRadius, percent, innerRadius, name} = props;

  const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);
  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline='central'>
      {name} - {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

class PieChartInLiquidations extends Component {
  render() {
    const {data} = this.props;
    return (
      <ResponsiveContainer width='100%' height={510}>
        <PieChart>
          <Pie
            nameKey='name'
            dataKey='total'
            data={data}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={230}
            fill="#8884d8"
            onClick={this.onPieClick}
          >
            {this.changeFillColor()}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    );
  }

  onPieClick = (index, data) => {
    const {type} = this.props;
    if (type === 'colors') {
      return;
    }
    const name = index.payload.name;
    this.props.onClickChangeType(type, name);
  }

  changeFillColor() {
    const {data} = this.props;
    return (
      data.map((entry, index) => <Cell key={index} fill={colors[index % colors.length]} />)
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default connect(mapStateToProps, {
})(PieChartInLiquidations);
